<script setup lang="ts">
import JobIdAndIconLinkUnit from '@/components/units/JobIdAndIconLinkUnit.vue';

export interface Props {
  jobs?: { jobId: number; jobDate: string }[];
}
export type DefProps = typeof props;
const props = withDefaults(defineProps<Props>(), {
  jobs: () => [],
});
</script>

<template>
  <ul :class="$style.jobsBasicList" data-testid="jobsBasicList">
    <li
      v-for="job in props.jobs"
      :key="job.jobId + job.jobDate"
      :class="$style.jobsBasicListItem"
    >
      <JobIdAndIconLinkUnit :job-id="job.jobId" :job-date="job.jobDate" />
    </li>
  </ul>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.jobsBasicList {
}
  .jobsBasicListItem {
    line-height: 1.2;
    font-size: 14px;
    padding: 4px 0;
  }
</style>
